import { Link } from "react-router-dom";
import Header from "./Header";
import Footer from "./Footer";
import useSeo from "../hooks/useSeo";
import { SITE_NAME } from "../constants/seo";
import { TOPIC_SEO_LIST } from "../constants/topicSeo";

export default function TopicIndexPage() {
  useSeo({
    title: `婚恋专题_找对象脱单婚姻咨询 - ${SITE_NAME}`,
    metaDescription:
      "共同价值观、脱单相亲、婚姻咨询、婚恋咨询师陪伴、AI智能匹配等专题服务，AI婚恋平台从相识到结婚全程辅导。",
    ogDescription: "婚恋专题索引：找对象、脱单、婚姻咨询、AI匹配。",
    keywords:
      "共同价值观,脱单相亲,婚姻咨询,婚恋咨询师,AI婚恋,严肃婚恋,找对象",
    path: "/topic",
  });

  return (
    <div className="min-h-screen bg-gradient-to-br from-pink-50 to-purple-50 flex flex-col">
      <Header />

      <main className="flex-1 px-4 py-10">
        <div className="max-w-4xl mx-auto">
          <h1 className="text-3xl font-bold text-gray-800 mb-2">婚恋专题</h1>
          <p className="text-gray-600 mb-8">
            按需求选择专题，了解平台在找对象、脱单、婚姻咨询、咨询师陪伴与 AI 匹配等方面的服务。
          </p>

          <div className="grid sm:grid-cols-2 gap-4">
            {TOPIC_SEO_LIST.map((topic) => (
              <Link
                key={topic.slug}
                to={`/topic/${topic.slug}`}
                className="block bg-white rounded-xl shadow p-5 hover:shadow-md border border-transparent hover:border-pink-200 transition"
              >
                <p className="text-xs text-pink-500 font-medium mb-1">{topic.badge}</p>
                <h2 className="text-lg font-bold text-gray-800 mb-2">{topic.headline}</h2>
                <p className="text-sm text-gray-500 line-clamp-2">{topic.intro}</p>
              </Link>
            ))}
          </div>

          <div className="mt-10 text-center">
            <Link to="/city" className="text-pink-500 hover:underline text-sm">
              按城市查找 → 全国城市婚恋交友
            </Link>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
}
